import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Prevent CRA's dev-only "Uncaught runtime errors" red overlay from surfacing
// axios rejections that individual pages didn't defensively `.catch()`.
// The interceptor in lib/api.js already handles session-revoked cases; this
// guard just stops harmless network failures (403, timeouts) from being noisy.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const isAxios = !!reason?.isAxiosError || !!reason?.response;
    if (isAxios) {
      // Log at debug level; do not raise the CRA overlay.
      console.debug("Unhandled axios rejection:", reason?.response?.status, reason?.config?.url);
      event.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
